export enum GiveStepsEnum {
  OPTIONS = 0,
  SUMMARY = 1,
}
